(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tns-subscribe"] && !Shopify.designMode) return;
  try {
    (function () {
    var state = null;
    var GIFT_SVG = '<svg width="44" height="44" viewBox="0 0 44 44" fill="none" aria-hidden="true"><rect x="3" y="12" width="38" height="26" rx="8" fill="#1A1A1A"/><path d="M15 12v-2a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v2" stroke="#1A1A1A" stroke-width="3"/><path d="M3 24h38" stroke="#F7F5F2" stroke-width="1.5" stroke-dasharray="2 3"/></svg>';

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function niceFreq(raw) {
      var f = String(raw || '').replace(/^deliver every\s*/i, '').replace(/,.*$/, '').trim();
      if (/^(month|week|year)/i.test(f)) f = '1 ' + f;
      return f;
    }

    function months(s) {
      var m = /^(\d+)\s*month/i.exec(String(s || '').trim());
      return m ? parseInt(m[1], 10) : 0;
    }

    function currentVariantId(form) {
      var input = form && form.querySelector('[name="id"]');
      return input ? parseInt(input.value, 10) : null;
    }

    function variantData() {
      var id = currentVariantId(state.form);
      var list = state.data.variants;
      for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
      return list[0];
    }

    // Supply products: the variant whose Supply equals the plan's frequency (every 3 months -> 3 Months)
    function supplyVariant(freq) {
      var n = months(freq);
      if (!n) return null;
      var list = state.data.variants;
      for (var i = 0; i < list.length; i++) if (months(list[i].supply) === n) return list[i];
      return null;
    }

    function shortestSupply() {
      var best = null;
      state.data.variants.forEach(function (x) {
        if (months(x.supply) && (!best || months(x.supply) < months(best.supply))) best = x;
      });
      return best;
    }

    function supplyRadio(variant) {
      var radios = document.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (String(radios[i].value).trim().toLowerCase() === String(variant.supply).trim().toLowerCase()) return radios[i];
      }
      return null;
    }

    // The Supply picker only matters for one-time purchases; with a plan selected the frequency decides it
    function applyPicker() {
      if (!state || !state.supply) return;
      var any = null;
      var radios = document.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (months(radios[i].value)) { any = radios[i]; break; }
      }
      if (!any) return;
      var box = any.closest('variant-picker') || any.closest('fieldset');
      if (box) box.style.display = state.hidePicker ? 'none' : '';
    }

    function build(data) {
      var block = document.querySelector('.buy-buttons-block');
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!block || !form || block.dataset.tnsSub === '1' || document.querySelector('[data-tns-cs]')) return;
      block.dataset.tnsSub = '1';

      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'selling_plan';
      form.appendChild(hidden);

      var wrap = el('div', 'tns-sub');
      block.parentNode.insertBefore(wrap, block);

      var supply = data.variants.some(function (x) { return months(x.supply) > 0; });

      // sel: 'one' or the normalised frequency of a plan (e.g. "1 month"); null = default
      state = { data: data, form: form, hidden: hidden, wrap: wrap, sel: null, vid: null, supply: supply, hidePicker: false, switchedAt: 0 };

      render();
      setInterval(function () {
        if (currentVariantId(form) !== state.vid) render();
        applyPicker();
      }, 300);
      form.addEventListener('change', render);
    }

    function render() {
      if (!state) return;
      var v = variantData();
      state.vid = v.id;

      // one entry per delivery frequency; on supply products each is priced on its own supply variant
      var plans = (v.plans || []).map(function (pl) {
        var freq = niceFreq(pl.freq);
        var out = Object.assign({}, pl, { freq: freq, variant: v });
        if (state.supply) {
          var sv = supplyVariant(freq);
          if (sv) {
            var match = (sv.plans || []).filter(function (x) { return niceFreq(x.freq) === freq; })[0];
            if (match) out = Object.assign({}, match, { freq: freq, variant: sv });
          }
        }
        return out;
      });

      var sel = state.sel;
      var found = plans.some(function (p) { return p.freq === sel; });
      if (sel !== 'one' && !found) {
        sel = null;
        if (state.supply) {
          for (var s = 0; s < plans.length; s++) if (plans[s].variant.id === v.id) { sel = plans[s].freq; break; }
        }
        if (!sel) for (var k = 0; k < plans.length; k++) if (/^1\s*month/i.test(plans[k].freq)) { sel = plans[k].freq; break; }
        if (!sel && plans.length) sel = plans[0].freq;
        if (!sel) sel = 'one';
      }

      state.wrap.textContent = '';

      // one-time card
      var one = el('label', 'tns-sub__opt' + (sel === 'one' ? ' is-on' : ''));
      var r = el('div', 'tns-sub__row');
      r.appendChild(el('span', 'tns-sub__radio'));
      r.appendChild(el('span', 'tns-sub__title', state.data.oneTimeLabel));
      // one-time is always the 1-month supply price, whichever plan is being previewed
      var oneVariant = state.supply ? (shortestSupply() || v) : v;
      r.appendChild(el('span', 'tns-sub__price', oneVariant.oneTime));
      one.appendChild(r);
      one.addEventListener('click', function () { state.sel = 'one'; render(); });
      state.wrap.appendChild(one);

      // one card per delivery frequency
      var chosen = null;
      plans.forEach(function (p) {
        var on = sel === p.freq;
        if (on) chosen = p;
        var card = el('label', 'tns-sub__opt' + (on ? ' is-on' : ''));
        card.appendChild(el('span', 'tns-sub__badge', 'Save ' + p.saveAmount));

        var row = el('div', 'tns-sub__row');
        row.appendChild(el('span', 'tns-sub__radio'));
        row.appendChild(el('span', 'tns-sub__title', 'Subscribe & save – every ' + p.freq));
        var price = el('span', 'tns-sub__price');
        price.appendChild(el('s', null, p.compare));
        price.appendChild(document.createTextNode(p.price));
        row.appendChild(price);
        card.appendChild(row);

        var body = el('div', 'tns-sub__body');
        var line = el('div', 'tns-sub__line');
        line.appendChild(el('span', 'tns-sub__chip', 'Deliver every ' + p.freq));
        var per = el('div', 'tns-sub__per');
        per.appendChild(el('b', null, p.price));
        per.appendChild(document.createTextNode('per delivery'));
        line.appendChild(per);
        body.appendChild(line);

        var saved = el('div', 'tns-sub__saved');
        saved.appendChild(document.createTextNode('You save '));
        saved.appendChild(el('em', null, p.saveAmount + ' (' + p.savePct + '%)'));
        saved.appendChild(document.createTextNode(' on every delivery'));
        body.appendChild(saved);

        var gift = el('div', 'tns-sub__gift');
        gift.innerHTML = GIFT_SVG;
        var gt = el('div');
        gt.appendChild(el('b', null, state.data.gift));
        gt.appendChild(el('span', null, state.data.giftNote));
        gift.appendChild(gt);
        body.appendChild(gift);
        var fine = state.supply && p.variant.supply
          ? 'Each delivery is your ' + p.variant.supply.toLowerCase() + ' supply. Pause, skip or cancel anytime.'
          : 'Pause, skip or cancel anytime.';
        body.appendChild(el('div', 'tns-sub__fine', fine));
        card.appendChild(body);

        card.addEventListener('click', function () { state.sel = p.freq; render(); });
        state.wrap.appendChild(card);
      });

      state.hidden.value = chosen ? String(chosen.id) : '';
      if (!chosen) state.hidden.removeAttribute('value');

      // supply products: the chosen plan decides the variant (and hides the Supply picker)
      // the Supply picker is never shown: a plan decides the supply, one-time is the 1-month supply
      state.hidePicker = !!state.supply;
      applyPicker();
      var target = chosen ? chosen.variant : (state.supply ? shortestSupply() : v);
      if (state.supply && target && target.id !== v.id && Date.now() - state.switchedAt > 1200) {
        var radio = supplyRadio(target);
        if (radio) {
          state.switchedAt = Date.now();
          radio.click();
        }
      }

      var btn = state.form.querySelector('.add-to-cart-button');
      if (btn && v.available) {
        var base = btn.dataset.tnsBase || btn.textContent.replace(/\s*[–—-]\s*£.*$/, '').trim();
        btn.dataset.tnsBase = base;
        btn.textContent = base + ' – ' + (chosen ? chosen.price : oneVariant.oneTime);
      }
    }

    function init() {
      var script = document.querySelector('[data-tns-sub-data]');
      if (!script) return;
      try { build(JSON.parse(script.textContent)); } catch (e) {}
    }

    window.__tnsSubBuild = build;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
